import { environment } from 'src/environments/environment';
import { Menu } from './menu.model';


export const MenuData = [
  new Menu(1, 0, 'Página Inicial', '/', null, 'dna-grid', null, false, 0),

  new Menu(2, 0, 'Usuários', null, null, 'dna-users', null, true, 0),
  new Menu(3, 1, 'Usuários', null, environment.sso.web + '/system-user/users', 'dna-user-single', null, false, 2, true),
  new Menu(4, 2, 'Grupo de Usuários', null, environment.sso.web + '/system-user/user-groups', 'dna-user-group', null, false, 2, true),
  new Menu(5, 3, 'Permissões de Segurança', null, environment.sso.web + '/system-user/permissions', 'dna-shield', null, false, 2, true),
  new Menu(6, 4, 'Configurações de senha', null, environment.sso.web + '/system-user/password-settings', 'dna-lock', null, false, 2, true),

  new Menu(7, 0, 'Formulários', null, null, 'dna-form', null, true, 0),
  new Menu(8, environment.categoryid, 'Categorias', '/category', null, 'dna-category', null, false, 7),
  new Menu(9, environment.formId, 'Gerenciar Formulários', '/form', null, 'dna-form-manage', null, false, 7),
  new Menu(10, environment.formFillId, 'Preencher Formulários', '/form/fill', null, 'dna-form-fill', null, false, 7),

  new Menu(11, 0, 'Workflow', null, null, 'dna-workflow', null, true, 0),
  new Menu(12, environment.workflowStatusId, 'Status do Workflow', '/workflowstatus', null, 'dna-status', null, false, 11),
  new Menu(13, environment.workflowId, 'Workflow', '/workflow', null, 'dna-workflow', null, false, 11),

  new Menu(14, 0, 'Integração', null, null, 'dna-integration', null, true, 0),
  new Menu(15, environment.integration, 'Integração', '/integration', null, 'dna-integration', null, false, 14),
]
